import { render, staticRenderFns } from "./EformElement.vue?vue&type=template&id=4f0d31e2&scoped=true&"
import script from "./EformElement.vue?vue&type=script&lang=js&"
export * from "./EformElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0d31e2",
  null
  
)

export default component.exports